(function () {
  'use strict';

  function initializeHero(hero) {
    if (!hero || hero.dataset.emporiaInitialized === 'true') return;

    var slides = Array.prototype.slice.call(hero.querySelectorAll('[data-emporia-home-slide]'));
    var dots = Array.prototype.slice.call(hero.querySelectorAll('[data-emporia-home-hero-dot]'));
    var previous = hero.querySelector('[data-emporia-home-hero-previous]');
    var next = hero.querySelector('[data-emporia-home-hero-next]');
    var activeIndex = 0;

    hero.dataset.emporiaInitialized = 'true';
    if (slides.length < 2) return;

    function showSlide(index) {
      activeIndex = (index + slides.length) % slides.length;
      slides.forEach(function (slide, slideIndex) {
        var active = slideIndex === activeIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.querySelectorAll('a, button').forEach(function (element) {
          element.tabIndex = active ? 0 : -1;
        });
      });
      dots.forEach(function (dot, dotIndex) {
        dot.setAttribute('aria-current', String(dotIndex === activeIndex));
      });
    }

    if (previous) {
      previous.addEventListener('click', function () {
        showSlide(activeIndex - 1);
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        showSlide(activeIndex + 1);
      });
    }
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        showSlide(Number(dot.dataset.emporiaHomeHeroDot));
      });
    });
    hero.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') showSlide(activeIndex - 1);
      if (event.key === 'ArrowRight') showSlide(activeIndex + 1);
    });

    showSlide(0);
  }

  function initializeScroller(section) {
    if (!section || section.dataset.emporiaScrollerInitialized === 'true') return;

    var track = section.querySelector('[data-emporia-product-scroller-track]');
    var previous = section.querySelector('[data-emporia-product-scroller-previous]');
    var next = section.querySelector('[data-emporia-product-scroller-next]');
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    section.dataset.emporiaScrollerInitialized = 'true';
    if (!track || !previous || !next) return;

    function updateControls() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maxScroll - 2;
    }

    function scroll(direction) {
      track.scrollBy({
        left: direction * Math.max(track.clientWidth * 0.8, 240),
        behavior: reducedMotion ? 'auto' : 'smooth'
      });
    }

    previous.addEventListener('click', function () {
      scroll(-1);
    });
    next.addEventListener('click', function () {
      scroll(1);
    });
    track.addEventListener('scroll', updateControls, { passive: true });
    window.addEventListener('resize', updateControls);
    updateControls();
  }

  function initialize(root) {
    root.querySelectorAll('[data-emporia-home-hero]').forEach(initializeHero);
    root.querySelectorAll('[data-emporia-product-scroller]').forEach(initializeScroller);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialize(document);
    });
  } else {
    initialize(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });
})();
